import { Popup } from "react-leaflet";
import { Table } from "react-bootstrap";
import SimpleBar from "simplebar-react";
import kmlUtilities from "../../utilities/kmlUtilities";
import stringUtilities from "../../utilities/stringUtilities";

function LinkedText(props) {
    return <>
        {kmlUtilities.splitLinks(props.text).map((segment, index) => segment.url
            ? <a key={index} href={segment.url} target="_blank" rel="noopener noreferrer">{segment.text}</a>
            : <span key={index}>{segment.text}</span>
        )}
    </>
}

export default function KmlPopup(props) {

    const { name, description, attributes } = props.info;
    const attributeKeys = Object.keys(attributes);
    const hasName = !stringUtilities.isNullOrEmpty(name);
    const hasDescription = !stringUtilities.isNullOrEmpty(description);

    return <Popup className="data-popup kml-feature-popup" position={props.latlng} eventHandlers={{ remove: props.onClose }}>
        <div className='card border-0'>
            <div className='card-footer d-flex flex-column justify-content-center mx-2 px-0 text-nowrap'>
                <SimpleBar autoHide={false} className='simplebar-no-autohide' style={{ maxHeight: '15rem' }}>
                    <Table size="sm" striped>
                        <tbody>
                            {hasName &&
                                <tr>
                                    <td colSpan={2}><h3 className="h6 px-0 m-0">{name}</h3></td>
                                </tr>
                            }
                            {hasDescription &&
                                <tr>
                                    <td colSpan={2}><LinkedText text={description} /></td>
                                </tr>
                            }
                            {attributeKeys.map((key, index) => <tr key={`kml-popup-attribute-${index}`}>
                                <td><strong className="p-0">{key}</strong></td>
                                <td><LinkedText text={attributes[key]} /></td>
                            </tr>)}
                            {!hasName && !hasDescription && attributeKeys.length === 0 &&
                                <tr>
                                    <td colSpan={2}>No information available for this feature.</td>
                                </tr>
                            }
                        </tbody>
                    </Table>
                </SimpleBar>
            </div>
        </div>
    </Popup>
}
